import { AuthRoutes } from "../modules/AuthModule/routes";
import { DashboardRoutes } from "../modules/DashboardModule/routes";

export const ModuleRoutes = [...AuthRoutes, ...DashboardRoutes];
